import { Periodo } from 'shared/models/Periodo';

export class Tarjeta {
  id: number;
  numero: string;
  numeroCuenta: number;
  denominacion: string;
  periodo: Periodo;
  rubroId: number;
  isValidTarjeta: boolean;
  centroCostoAsociado: string;

  constructor(tarjeta: Partial<Tarjeta>) {
    this.numero = tarjeta.numero;
    this.numeroCuenta = tarjeta.numeroCuenta;
    this.denominacion = tarjeta.denominacion;
    this.periodo = tarjeta.periodo;
    this.rubroId = tarjeta.rubroId;
    this.isValidTarjeta = tarjeta.isValidTarjeta;
    this.id = tarjeta.id;
    this.centroCostoAsociado = tarjeta.centroCostoAsociado;
  }
}
